import throttle from "@Utils/throttle";
import { PAGE } from "constants/configConstants";
import uetEventEmitter from "helpers/uetEventEmitter";
import { useEffect } from "react";

const useToggleShowNavbar = (elementRef: any, setIsElementScrolledUp: any, page = PAGE.HOME) => {
  useEffect(() => {
    const handleScrollThrottled = throttle(() => {
      if (elementRef.current) {
        const { top } = elementRef.current.getBoundingClientRect();
        const isAboveViewport = top < 0;
        setIsElementScrolledUp(isAboveViewport);
      }
    }, 400);

    window.addEventListener("scroll", handleScrollThrottled);
    uetEventEmitter({ action: "view", category: page, label: "", value: "" });

    return () => {
      window.removeEventListener("scroll", handleScrollThrottled);
    };
  }, []);
};

export default useToggleShowNavbar;
